import { render, staticRenderFns } from "./award-drawer.vue?vue&type=template&id=5876d5cb&"
import script from "./award-drawer.vue?vue&type=script&lang=js&"
export * from "./award-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports